export const LOCATE_TYPICAL_UNDO = 'LOCATE_TYPICAL_UNDO';
export const LOCATE_TYPICAL_REDO = 'LOCATE_TYPICAL_REDO';
export const GROUND_FLOOR = 'GROUND_FLOOR';
export const TYPICAL_FLOOR = 'TYPICAL_FLOOR';
